import { render, staticRenderFns } from "./RotateImage.vue?vue&type=template&id=2bea57f2&scoped=true&"
import script from "./RotateImage.vue?vue&type=script&lang=js&"
export * from "./RotateImage.vue?vue&type=script&lang=js&"
import style0 from "./RotateImage.vue?vue&type=style&index=0&id=2bea57f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bea57f2",
  null
  
)

export default component.exports